<template>
  <v-container fluid grid-list-lg>

    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-layout align-center justify-center column pb-2>
          <h2 class="heading-3">Activate your account</h2>
          <p>We've sent a verification code to your email address.</p> 
          <p>Please enter your email and the verification code below to verify your account.</p>
          <p><em>If you are confirming a new {{configStrings.productName}} and have clicked the link in the email, the email and the verification code will be populated automatically.</em></p>
        </v-layout>

        <v-alert :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" @submit="confirm">

            <v-text-field outline v-model="username" :rules="usernameRules" label="Email" type="email"  required ></v-text-field>

            <v-text-field outline v-model="code" :rules="codeRules" label="Confirmation code" required ></v-text-field>

            <v-layout row align-center mx-1>
              <router-link to="/send-confirm-code" class="text-button">Need a new verification code?</router-link>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Verify</button>
            </v-layout>

          </v-form>

        </v-layout>

      </v-flex>
    </v-layout>

  </v-container>
</template>


<script>
export default {
  name: 'Login',
  data () {
    
    return {
      valid: true,
      codeRules: [
        v => !!v || 'Confirmation code must be enetered',
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid',
        v => (!v.includes(' ')) || 'An email address can not contain any spaces'
      ],
      username: '',
      code: '',
      error: null,
      loading: false
    }
  },
  mounted (){
    
    // check for query string params to populate
    var search = location.search.substring(1);
    var parameters = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
    //alert(parameters)
    console.log(parameters)
    if(parameters.code.length === 6){
      this.code = parameters.code
    }
    if(parameters.email){
      this.username = decodeURIComponent(parameters.email).replace(' ','+')
    }

  },
  methods: {
    confirm (e) {
      e.preventDefault()
        this.loading = true
        var email = this.username
        var confCode = this.code

        this.$confirmRegistration(email, confCode).subscribe((data) => {

            if (typeof window.android !== 'undefined') { 
              window.android.onRegistrationConfirmed() 
            }
            if (typeof window.webkit !== 'undefined') { 
              
              window.webkit.messageHandlers.iOS.postMessage('registrationConfirmed')
            }

            console.log('confirm success');
            if(localStorage.loginFlow === "oauth2") {
              this.$router.push("/oauth2/authorize");
            } else {
              this.$router.push("/login-post-verify");
            }
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err);
            if(err.code === "UnknownError"){
                this.$router.push("/login-set-password");
            }
            console.log(err.message);
            this.error = err;
        });

        /*this.$store.dispatch('confirmRegistration', {email: email, verificationCode: confCode}).then(() => {
            console.log("login successful");
            this.$router.push("/login");
        })
        .catch((err) => {
            console.log(err.message);
            this.error = err;
            
        }); */    
    }
  }
}
</script>

<style scoped>
</style>